import React from "react";
import { FaHeart, FaRegCommentDots, FaShare } from "react-icons/fa";
import { abbreviateNumber } from "@utility/index";

export default function PostShareBar({
  post,
  setDownloadAppModalOpen,
  setShareLinksModal,
}) {
  return (
    <div className="py-4 px-8 flex flex-row justify-end z-10 ">
      <div className="flex w-full">
        <div className="flex items-center mr-5 ">
          <div
            aria-hidden
            className="w-9 h-9 bg-gray-100 p-2.5 rounded-full flex items-center justify-center cursor-pointer"
            onClick={() => setDownloadAppModalOpen(true)}
          >
            <FaHeart className="h-full w-full" />
          </div>
          <div className="pl-1">
            <span>{abbreviateNumber(post.likeCount)}</span>
          </div>
        </div>
        <div className=" flex items-center mr-2">
          <div
            aria-hidden
            className="w-9 h-9 bg-gray-100 p-2 rounded-full flex items-center justify-center cursor-pointer"
            onClick={() => setDownloadAppModalOpen(true)}
          >
            <FaRegCommentDots className="h-full w-full" />
          </div>
          <div className="px-2">
            <span>{abbreviateNumber(post.commentCount)}</span>
          </div>
        </div>
        <div className=" flex items-center mr-2">
          <div
            aria-hidden
            className="w-9 h-9 bg-gray-100 p-2 rounded-full flex items-center justify-center cursor-pointer"
            onClick={() => setShareLinksModal(true)}
          >
            <FaShare className="h-[95%] w-[95%]" />
          </div>
        </div>
      </div>
    </div>
  );
}
